import { Affix } from 'antd';
import '@src/styles/components/customStickyBar.scss';
import PropTypes from 'prop-types';

const CustomStickyBar = ({ children, customTemplate, ...props }) => {
  return (
    <Affix className="custom-sticky" offsetBottom={0} {...props}>
      <div id="custom-sticky-container" className={`custom-sticky-bar ${customTemplate}`}>
        {children}
      </div>
    </Affix>
  );
};

CustomStickyBar.propTypes = {
  children: PropTypes.any,
  customTemplate: PropTypes.string,
};

export default CustomStickyBar;
